module.exports = __webpack_public_path__ + "img/testing.83e1d1c4.png";